import { Popover, Tabs } from "radix-ui";
import { SideBarMenuButton } from "../../../../ProjectFilter/SideBarMenu/SideBarMenuButton";
import { useState } from "react";
import clsx from "clsx";
import TrashIcon from "../../../../atom/icons/TrashIcon";
import SpaceTabContent from "./SpaceTabContent";
import { juneTrack } from "../../../../../utils/june/analytics";
import { JUNE_EVENT } from "../../../../../hooks/june/juneEvent";
import TaskTabContent from "./TaskTabContent";
import ModalPanel from "../Common";

const TrashPopover = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    open && juneTrack(JUNE_EVENT.VIEW_TRASH, { type: "space" });
  };

  const handleTabChange = (value: string) => {
    juneTrack(JUNE_EVENT.VIEW_TRASH, { type: value });
  };

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
      modal={true}
    >
      <Popover.Trigger asChild>
        <SideBarMenuButton
          className={clsx(isOpen && "bg-w-8-hover")}
          tooltipLabel={"Trash"}
        >
          <TrashIcon color={isOpen ? "#69E4FF" : "#CACDCE"} />
        </SideBarMenuButton>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="end"
          alignOffset={-9}
          side="right"
          sideOffset={15}
          onFocusOutside={(e) => e.preventDefault()}
          onCloseAutoFocus={(e) => e.preventDefault()}
          className={clsx(
            "z-[100] h-[520px] w-[300px] rounded-[7px] border border-solid border-25 bg-20 focus:outline-none",
            "origin-bottom-left data-[state=closed]:animate-popup-scale-out data-[state=open]:animate-popup-scale-in"
          )}
        >
          <Tabs.Root
            defaultValue="space"
            className="flex h-full flex-col justify-between"
            onValueChange={handleTabChange}
          >
            <ModalPanel.Header>
              <ModalPanel.Title>Trash</ModalPanel.Title>
              <Tabs.List className="flex gap-[4px]">
                <Tabs.Trigger
                  value="space"
                  className={clsx(
                    "rounded-[5px] px-[6px] py-[3px] text-[13px] leading-[140%] text-80",
                    "hover:bg-w-8-hover hover:text-white",
                    "data-[state=active]:bg-w-16 data-[state=active]:text-white"
                  )}
                >
                  Spaces
                </Tabs.Trigger>
                <Tabs.Trigger
                  value="task"
                  className={clsx(
                    "rounded-[5px] px-[6px] py-[3px] text-[13px] leading-[140%] text-80",
                    "hover:bg-w-8-hover hover:text-white",
                    "data-[state=active]:bg-w-16 data-[state=active]:text-white"
                  )}
                >
                  Tasks
                </Tabs.Trigger>
              </Tabs.List>
            </ModalPanel.Header>
            <Tabs.Content
              value="space"
              className="h-full focus:outline-none"
            >
              <SpaceTabContent />
            </Tabs.Content>
            <Tabs.Content
              value="task"
              className="h-full focus:outline-none"
            >
              <TaskTabContent />
            </Tabs.Content>
          </Tabs.Root>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default TrashPopover;
